import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

/**
 * Sends a page_view event to Google Analytics on every route change.
 * gtag is configured with send_page_view: false in index.html, so this
 * hook is the single source of page view tracking for the SPA.
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);
};

export default usePageTracking;
